var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSlideLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.99,
    height: 74.479,
    viewBox: "0 0 45.99 74.479",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-navigate-back",
    "data-name": "Icon material-navigate-back",
    d: "M21.636,9l-8.751,8.751L41.311,46.239,12.885,74.727l8.751,8.751L58.875,46.239Z",
    transform: "translate(58.875 83.479) rotate(180)",
    fill: "#e8dfd0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSlideLeft);
export default __webpack_public_path__ + "static/media/icon-slide-left.a349356d419b294f34193a561f8e5b7e.svg";
export { ForwardRef as ReactComponent };